import { useState } from "react";
import { NavLink } from "react-router-dom";
import "../css/menu.css";

function Menu() {
  // Estado para controlar si el menú está abierto
  const [isOpen, setIsOpen] = useState(false);

  // Función para alternar el estado
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="menu">
      {/* Añadimos la clase 'open' condicionalmente */}
      <div className={`menu-links ${isOpen ? "open" : ""}`} id="menuLinks">
        <NavLink title="Home" to="/" onClick={() => setIsOpen(false)}>
          Home
        </NavLink>
        <NavLink
          title="Call for papers"
          to="/call-for-papers"
          onClick={() => setIsOpen(false)}
        >
          Call for papers
        </NavLink>

        <NavLink title="Loja" to="/loja" onClick={() => setIsOpen(false)}>
          Loja
        </NavLink>
       <NavLink
  to="/#inscripcion"
  className="btn-inscribete"
  onClick={() => setIsOpen(false)}
>
  Inscríbete ahora
</NavLink>
      </div>

      {/* Botón hamburguesa con evento onClick */}
      <button
        className={`menu-toggle ${isOpen ? "active" : ""}`}
        onClick={toggleMenu}
        aria-label="Abrir menú"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </nav>
  );
}

export default Menu;
